import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import checkOutsideURL from '@utils/checkOutsideUrl';
import removeHostFromUrl from '@utils/removeHostFromUrl';

export default function LinkWrapper({ url, children, onClick }) {
  const isOutsideUrl = useMemo(() => checkOutsideURL(url), [url]);

  if (isOutsideUrl) {
    return (
      <a href={url} onClick={onClick} target='_blank' rel='noopener noreferrer'>
        {children}
      </a>
    );
  }

  return (
    <Link to={removeHostFromUrl(url)} onClick={onClick}>
      {children}
    </Link>
  );
}

LinkWrapper.defaultProps = {
  children: '',
  onClick: () => {},
};

LinkWrapper.propTypes = {
  url: PropTypes.string.isRequired,
  children: PropTypes.node,
  onClick: PropTypes.func,
};
